import { eventbus } from '../utils/eventBus'

export const checkoutComEvents = eventbus()
